import Block from '@/components/Block'
import Button from '@/components/Button'
import CardBlock from '@/compositions/CardBlock'
import { coreLayoutContainer, coreLayoutSection } from '@/constants/measured-scope'
import { SeriesClassesPageSection } from '@/shared/api-generated-types'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import React from 'react'

export interface Props extends Partial<SeriesClassesPageSection> {}

const SeriesClassesBlock = ({ ...props }: Props): JSX.Element | null => {
  const router = useRouter()
  const { t } = useTranslation('common')

  const handleScheduleRoute = (): void => {
    router.push(`/schedule/browse`)
  }

  if (!props.items?.length)
    return (
      <Block className={`${coreLayoutSection}`}>
        <div className={`${coreLayoutContainer}`}>
          <div className="ta-c">
            <p className="mb-md">{t('seriesFallbackMessage')}</p>
            <Button label={t('mySchedule.browseClasses')} theme="primary" size="lg" onClick={handleScheduleRoute} />
          </div>
        </div>
      </Block>
    )

  const items = props.items?.map((item) => {
    return {
      ...item,
      start: item.upcomingSession?.start,
      isCommunityLedClass: item.upcomingSession?.isCommunityLedClass,
      isEncore: item.upcomingSession?.isEncore,
      end: item.upcomingSession?.end,
      title: item.title,
      sessionId: item.upcomingSession?.sessionId,
      sponsor: item.upcomingSession?.sponsor,
    }
  })

  return <CardBlock cardType="feed" theme="white" items={items} hideBookmark />
}
export default React.memo(SeriesClassesBlock)
